export const productBraindwMapper = (
  products: Array<[BraindwReturnedShelfProps]>
) => {
  return products?.map((prod: BraindwReturnedShelfProps[]) => {
    return prod?.map((p: BraindwReturnedShelfProps) => ({
      id: p?.productId,
      slug: p?.linkText,
      sku: p?.items[0]?.itemId,
      clusterHighlights: p?.clusterHighlights,
      name: p?.productName,
      unitMultiplier: p?.items[0]?.unitMultiplier,
      measurementUnit: p?.items[0]?.measurementUnit,
      isVariantOf: null,
      img: {
        url: p?.items[0]?.images[0].imageUrl.replace(
          'vteximg.com.br',
          'vtexassets.com'
        ),
        alternateName: p?.items[0]?.images[0].imageText,
      },
      offers: {
        price: p?.items[0]?.sellers[0]?.commertialOffer?.ListPrice,
        spotPrice: p?.items[0]?.sellers[0]?.commertialOffer?.Price,
        priceWithoutDiscount:
          p?.items[0]?.sellers[0]?.commertialOffer?.PriceWithoutDiscount,
        offer: p?.items[0]?.sellers[0]?.commertialOffer?.IsAvailable,
        availableQuantity:
          p?.items[0]?.sellers[0]?.commertialOffer?.AvailableQuantity,
      },
    }))
  })
}
